module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CdJEwN/tc-custom/9781960332585.jpg?1732162721358",
      "alt": "This image is the cover for the book Rubicon, The Spy-fi 'Timberwolf' Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rubicon, The Spy-fi 'Timberwolf' Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A civil war simmers, alien threats are on the rise, and an angry clone plots the destruction of the entire human race –and again it’s Timberwolf Velez at the center of all the action!As Dr. Tier’s Department of Peace Enforcement and the Assault Corps square off, there’s a hidden plot in motion. A reborn Emmanuel Gray has been dispatched by a mysterious master to wake The Symmetry – an ancient force that knows nothing but obliteration. Timberwolf has to hunt Gray across fantastical alien worlds, deal with the most dangerous enemy the human race has ever known and rescue the only person he cares about in the entire galaxy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom Julian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tom Julian works days at pharmaceutical company, helping to support cancer  research, and nights and weekends as an author. He enjoys traveling, long-distance cycling, and waking up early to brew the perfect cup of coffee. He’s an unabashed beer snob and native of Trenton, New Jersey. Tom works hard to create cinematic experiences for the page. He is the father of Astur and Liam and husband to the lovely Brenda-Lea. Favorite movie/book/food = O Brother, Where Art Thou?/The Sirens of Titan/Trenton-style tomato pie.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WildBlue Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0